{
  "name": "31-(7-Limit) Fokker",
  "description": "31-tone 7-Limit Rational Intonation scale by Adriaan Fokker, consisting of 31 notes per octave derived from harmonic partial row intervals up to a prime limit of 7. Fokker was an early advocate of extending the conventional tone system beyond 12 notes, and advocated adoption of a 31-tone system. He is also a key figure in Rational Intonation and temperament research, inventing the concept of periodicity blocks. Compare this rational tuning to extended Quarter Comma Meantone and the 31edo temperament.",
  "scale": [
    "64/63",
    "135/128",
    "15/14",
    "35/32",
    "9/8",
    "8/7",
    "7/6",
    "135/112",
    "315/256",
    "5/4",
    "9/7",
    "21/16",
    "4/3",
    "175/128",
    "45/32",
    "10/7",
    "35/24",
    "3/2",
    "32/21",
    "14/9",
    "45/28",
    "105/64",
    "5/3",
    "12/7",
    "7/4",
    "16/9",
    "945/512",
    "15/8",
    "40/21",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "31-JI-7L(Fokker)",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "C",
    "C",
    "D",
    "D",
    "D",
    "E",
    "D",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "F",
    "F",
    "G",
    "G",
    "G",
    "A",
    "G",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "C"
  ],
  "note_colors": [
    "#ff9090",
    "#e5b9bb",
    "#e6e0cb",
    "#f4cdc1",
    "#ffcba8",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#f4cdc1",
    "#ffcba8",
    "#fffae5",
    "#e5b9bb",
    "#ffe5e5",
    "#ffffff",
    "#ffd270",
    "#e6e0cb",
    "#f4cdc1",
    "#ffcba8",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#f4cdc1",
    "#ffcba8",
    "#fffae5",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#ffcba8",
    "#fffae5",
    "#f4cdc1",
    "#ffe5e5"
  ],
  "equivSteps": 31,
  "fundamental": 260.740741,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 5,
  "drSteps": 3,
  "hexSize": 42,
  "rotation": -16.102113751
}
